const prefix = ''

export const snmpOidsUrls = {
  'oids.list': `${prefix}/oids`,
  'oids.add': `${prefix}/oids/create`,
  'oids.edit': (deviceId = ':deviceId', tab = ':tabValue') =>
    `${prefix}/oids/${deviceId}/edit/${tab}`,
}
